module.exports = __webpack_public_path__ + "static/media/employee.256053ec.png";